<template>
  <IframeWrap :option="wrapSize" @loaded="handleLoad">
    <iframe
      allowfullscreen="true"
      :src="fullSrc"
      class="min-w-full"
      style="height: 100%"
      allow="clipboard-read"
    />
  </IframeWrap>
</template>

<script lang="ts">
import { isProd } from '@/sandbox-utils/utils';
import { Content } from '@forchange/storytime';
import { Component, Prop, Vue } from 'vue-property-decorator';
import IframeWrap from '@/components/iframe-wrap';
import { IIframewrap } from '@/components/iframe-wrap/type';

interface ExtraAttr {
  // defalut active database-table name
  defaultTblName?: string;
  // Database init required
  data: string;
  // Editor defalut value
  code: string;

  type: 'sqlite' | 'tidb';

  goal?: string;
}

type ExtraAttrKeys = keyof ExtraAttr;

@Component({
  components: {
    IframeWrap
  }
})
export default class SQLIframe extends Vue {
  @Prop({ type: Object }) content!: Content & ExtraAttr & IIframewrap;

  // eslint-disable-next-line @typescript-eslint/class-literal-property-style
  get databaseType() {
    return this.content.type;
  }

  get origin() {
    return `https://${isProd ? 'prod' : 'test'}.pandateacher.com/web/sql/database/${
      this.databaseType
    }`;
  }

  get fullSrc() {
    const _url = new URL(this.origin);
    const keys: ExtraAttrKeys[] = ['data', 'code', 'defaultTblName', 'goal'];
    Object.keys(this.content).forEach((key) => {
      const _value = this.content[key as ExtraAttrKeys];
      if (keys.includes(key as ExtraAttrKeys) && !!_value) {
        if (key === 'code') {
          _url.searchParams.append(_value.startsWith('https') ? 'code' : 'sql', _value);
          return;
        }
        _url.searchParams.append(key, _value);
      }
    });
    return _url;
  }

  get wrapSize() {
    return {
      width: this.content.width,
      height: this.content.height
    };
  }

  handleLoad() {
    this.$emit('loaded');
  }
}
</script>
